import React from 'react';
import './DashboardCard.css';
import { Link } from 'react-router-dom';

function DashboardCard({ CardIcon, title, count, variant = 'default', to }) {
  const content = (
    <div className={`dashboard-card ${variant === 'dark' ? 'dashboard-card-dark' : ''}`}>
      <span className="dashboard-card-icon">{CardIcon}</span>
      <div className="card-content">
        <h2 className="card-count">{count}</h2>
        <p className="card-title">{title}</p>
      </div>
    </div>
  );
  return to ? (
    <Link to={to} className="dashboard-card-link">
      {content}
    </Link>
  ) : content;
}

export default DashboardCard;
